export default "__VITE_ASSET__Ce3qc2Gc__"